import OSM from 'ol/source/OSM';
import XYZ from 'ol/source/XYZ';
import TileLayer from 'ol/layer/Tile';

const baseLayers = [
/*   new TileLayer({
    title: 'Google Maps Uydu',
    source: new XYZ({
      url: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
    }),
    baseLayer: true,
    visible: true,
  }),
  new TileLayer({
    title: 'Esri Uydu',
    source: new XYZ({
      url: 'https://fly.maptiles.arcgis.com/arcgis/rest/services/World_Imagery_Firefly/MapServer/tile/{z}/{y}/{x}',
    }),
    baseLayer: true,
    visible: false,
  }), */
  new TileLayer({
    title: 'Google Maps Arazi',
    source: new XYZ({
      url: 'https://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',
    }),
    baseLayer: true,
    visible: false,
  }),
  new TileLayer({
    title: 'Esri Topografik',
    source: new XYZ({
      url: 'https://server.arcgisonline.com/arcgis/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}s',
    }),
    baseLayer: true,
    visible: false,
  }),
  new TileLayer({
    title: 'Google Maps Yol',
    source: new XYZ({
      url: 'https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
    }),
    baseLayer: true,
    visible: true,
  }),
  new TileLayer({
    title: 'Esri Yol',
    source: new XYZ({
      url: 'https://server.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
    }),
    baseLayer: true,
    visible: false,
  }),
  new TileLayer({
    title: 'OpenStreetMap Yol',
    source: new OSM(),
    baseLayer: true,
    visible: false,
  }),
  new TileLayer({
    title: 'OpenStreetMap Arazi',
    source: new XYZ({
      url: 'https://vtile01.maptoolkit.net/raster/toursprung/terrain/{z}/{x}/{y}.png',
    }),
    baseLayer: true,
    visible: false,
  }),
  new TileLayer({
    title: 'OpenTopoMap Arazi',
    source: new XYZ({
      url: 'https://a.tile.opentopomap.org/{z}/{x}/{y}.png',
    }),
    baseLayer: true,
    visible: false,
  }),
  new TileLayer({
    title: '4UMaps',
    source: new XYZ({
      url: 'https://tileserver.4umaps.com/{z}/{x}/{y}.png',
    }),
    baseLayer: true,
    visible: false,
  }),
  new TileLayer({
    title: 'CARTO Maps',
    source: new XYZ({
      url: 'https://a.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png',
    }),
    baseLayer: true,
    visible: false,
  }),
];

export default baseLayers;
